

import React from 'react';
import { Card, Row, Col, Typography, Divider } from 'antd';
import { TeamOutlined, HeartOutlined, GlobalOutlined } from '@ant-design/icons';

const { Title, Paragraph, Text } = Typography;

const About = () => {
  return (
    <div className="about-page" style={{ padding: '20px 0' }}>
      <div className="container">
        {/* Section Notre Histoire */}
        <Card className="mb-4" style={{ boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)' }}>
          <div style={{ textAlign: 'center', marginBottom: '30px' }}>
            <Title level={1} style={{ color: '#1890ff' }}>
              <GlobalOutlined /> À Propos de Nomidya
            </Title>
          </div>

          <Row gutter={[24, 24]}>
            <Col xs={24} lg={12}>
              <Card 
                hoverable 
                style={{ height: '100%', background: 'linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%)' }}
                bodyStyle={{ padding: '30px' }}
              >
                <Title level={2} style={{ color: '#1890ff', textAlign: 'center' }}>
                  <HeartOutlined /> Notre Histoire
                </Title>
                <Divider />
                <Paragraph style={{ fontSize: '16px', lineHeight: '1.8', textAlign: 'justify' }}>
                  Il était une fois, dans le monde de l'entreprise, des individus passionnés, des consultants et gestionnaires chevronnés travaillant pour des multinationales renommées. Ayant gravi les échelons de leur carrière grâce à leurs compétences exceptionnelles et à leur dévouement, ils ont acquis une expertise inestimable.
                </Paragraph>
                <Paragraph style={{ fontSize: '16px', lineHeight: '1.8', textAlign: 'justify' }}>
                  Alors que leur réussite professionnelle était épanouissante, une idée germa dans leur esprit : partager leurs connaissances et leurs expériences avec le monde entier. Ils voulaient créer une plateforme éducative qui donnerait à chacun l'accès aux connaissances et aux compétences qui ont fait leur succès.
                </Paragraph>
                <Paragraph style={{ fontSize: '16px', lineHeight: '1.8', textAlign: 'justify' }}>
                  Ainsi est née <Text strong style={{ color: '#1890ff' }}>Nomidya</Text>, une plateforme e-learning qui allait révolutionner l'apprentissage en ligne. Les fondateurs ont rassemblé une équipe de professionnels passionnés, tous animés par la même vision : offrir des cours de haute qualité, basés sur des expériences du monde réel, pour permettre aux apprenants de développer des compétences de niveau supérieur.
                </Paragraph>
              </Card>
            </Col>
            
            <Col xs={24} lg={12}>
              <Card 
                hoverable 
                style={{ height: '100%', background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)', color: 'white' }}
                bodyStyle={{ padding: '30px' }}
              >
                <Title level={2} style={{ color: 'white', textAlign: 'center' }}>
                  <TeamOutlined /> Notre Évolution
                </Title>
                <Divider style={{ borderColor: 'rgba(255,255,255,0.3)' }} />
                <Paragraph style={{ fontSize: '16px', lineHeight: '1.8', textAlign: 'justify', color: 'white' }}>
                  Au fil du temps, Nomidya est devenue le lieu où des apprenants du monde entier, aspirant à devenir des experts dans leur domaine, se sont rassemblés. Les cours proposés, conçus avec soin par les fondateurs eux-mêmes, ont permis aux apprenants de trouver leur propre espace pour apprendre, où et quand ils le souhaitaient.
                </Paragraph>
                <Paragraph style={{ fontSize: '16px', lineHeight: '1.8', textAlign: 'justify', color: 'white' }}>
                  Aujourd'hui, Nomidya est devenue un leader mondial, avec des participants dans plus de <Text strong style={{ color: '#ffd700' }}>175 pays</Text>. Grâce à leur approche flexible et à leur enseignement axé sur la pratique, les apprenants peuvent progresser dans leur carrière, devenir des professionnels de premier ordre, des gestionnaires de projet accomplis, et bien plus encore.
                </Paragraph>
                <Paragraph style={{ fontSize: '16px', lineHeight: '1.8', textAlign: 'justify', color: 'white' }}>
                  La famille Nomidya continue de guider leur plateforme de formation professionnelle en ligne avec passion et détermination, toujours désireux de partager leur expertise avec le plus grand nombre.
                </Paragraph>
              </Card>
            </Col>
          </Row>

          <Card style={{ marginTop: '30px', background: '#f0f2f5', textAlign: 'center' }}>
            <Title level={3} style={{ color: '#1890ff' }}>
              L'Aventure Continue
            </Title>
            <Paragraph style={{ fontSize: '18px', lineHeight: '1.8', maxWidth: '800px', margin: '0 auto' }}>
              Ainsi, l'aventure continue, avec Nomidya, où l'apprentissage rencontre l'innovation et l'expertise rencontre l'ambition, ouvrant ainsi les portes vers un avenir de possibilités infinies pour tous ceux qui osent rêver et apprendre.
            </Paragraph>
          </Card>
        </Card>
      </div>
    </div>
  );
};

export default About;
